// extracted by mini-css-extract-plugin
module.exports = {"container":"MoreButton_container__1KCWv","layout":"MoreButton_layout__1Dgwx"};